import { render, staticRenderFns } from "./DataFList.vue?vue&type=template&id=253ac348&scoped=true"
import script from "./DataFList.vue?vue&type=script&lang=js"
export * from "./DataFList.vue?vue&type=script&lang=js"
import style0 from "./DataFList.vue?vue&type=style&index=0&id=253ac348&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ac348",
  null
  
)

export default component.exports